import { atom } from 'recoil';

export const phoneSearch = atom({
  key: 'phoneSearch', // unique ID (with respect to other atoms/selectors)
  default: {
    cc: '',
    pattern: '',
    sms: '',
  }, // default value (aka initial value)
});
